import { useEffect, useRef } from 'react';

export const useInfiniteScroll = (callback) => {
    const observer = useRef();

    useEffect(() => {
        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                callback();
            }
        });

        const node = document.getElementById('scroll-anchor');
        if (node) observer.current.observe(node);

        return () => observer.current.disconnect();
    }, [callback]);
};
